module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 'f',
        title: 'New Bag',
        description: 'Quick Search Patients'
      }),
      expression: "{keys: 'f', title:'New Bag', description: 'Quick Search Patients'}"
    }],
    on: {
      "shortkey": _vm.setSearchFocus
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('h4', [_vm._v("Search Existing Patients")]), _vm._v(" "), _c('PatientSearchBox', {
    attrs: {
      "focus": _vm.searchFocus
    },
    model: {
      value: (_vm.Patient),
      callback: function($$v) {
        _vm.Patient = $$v
      },
      expression: "Patient"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Create New Patient")]), _vm._v(" "), _c('NewPatientForm', {
    model: {
      value: (_vm.Patient),
      callback: function($$v) {
        _vm.Patient = $$v
      },
      expression: "Patient"
    }
  })], 1)]), _vm._v(" "), (_vm.Patient != null) ? _c('div', {
    staticClass: "row well"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-6 "
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.Patient.firstName) + " " + _vm._s(_vm.Patient.lastName))]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(1), _c('td', [_c('small', [_vm._v(_vm._s(_vm.FormatDate(_vm.Patient.dob)))])])]), _vm._v(" "), _c('tr', [_vm._m(2), _c('td', [_c('small', [_vm._v(_vm._s(_vm.Patient.nhsNumber))])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.Patient.addressLine) + "       ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Patient.postCode) + "    ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 's',
        title: 'New Bag',
        description: 'Submit / Create (if patient selected)'
      }),
      expression: "{keys:'s', title:'New Bag', description:'Submit / Create (if patient selected)'}"
    }],
    on: {
      "shortkey": _vm.create
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 'c',
        title: 'New Bag',
        description: 'Cancel Patient Selection'
      }),
      expression: "{keys:'c', title:'New Bag', description:'Cancel Patient Selection'}"
    }],
    on: {
      "shortkey": _vm.create
    }
  }), _vm._v(" "), (_vm.Patient != null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v("     Create Bag")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 'c',
        title: 'New Bag',
        description: 'Cancel Patient Selection'
      }),
      expression: "{keys:'c', title:'New Bag', description:'Cancel Patient Selection'}"
    }],
    staticClass: "btn btn-warning",
    on: {
      "shortkey": function($event) {
        _vm.Patient = null
      },
      "click": function($event) {
        _vm.Patient = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Cancel")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-bottom": "1px solid gray"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_vm._v("\n             \n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Dob :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Nhs Id :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Address :")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bb8e219", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb8e219"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/BagManagement/NewBag.scp.html
// module id = 494
// module chunks = 0